import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import ModalCustom from './../../../../common/modalCustom/modalCustom';

import { useLocation, useHistory } from 'react-router-dom';


let useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        padding: '10px 16px 10px 16px',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center'
    },
    gridCard: {
        marginTop: 21,
    },
    modal: {
        width: '518px',
        maxWidth: '98%',
        borderRadius: '12px 12px 12px 12px !important',
        "@media(max-width : 900px)": {
            maxWidth: 360
        },
        "@media(max-width : 400px)": {
            maxWidth: '100%',
        },
    },
    close: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        padding: '10px'
    },
    images: {
        width: 300,
        '@media (max-width: 800px)': {
            maxWidth: '95%'
        },
    },
    gridButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '20px 0px',
    },
    Button: {
        width: '250px !important',
        padding: '10px 55px !important',
        backgroundColor: "#091742 !important",
        color: 'white !important',
        marginTop: '0px !important',
        borderRadius: '8px !important '
    },
    title: {
        marginBottom: 10,
    }
}))





const Contract = ({ open, onClose }) => {

    let classes = useStyles()
    const location = useLocation();
    const navigate = useHistory();

    const { token, national_id , sejamProfile } = location.state || {};


    const handelClick = () => {
        onClose()
        navigate('/deceased/user/requests', { state: { sejamProfile: {...sejamProfile}, token: token } });
    }

    return (
        <ModalCustom
            open={open}
            onClose={onClose}
            className={classes['modal']}
        >
            <div className={classes['root']} onClick={(event) => event.stopPropagation()}>

                <img
                    src={'/assets/images/register.png'}
                    alt=""
                    className={classes['images']}
                />
                <p className={classes['title']} style={{ fontWeight: 'bold', padding: '0px 5px', display: 'inline-block' }}>
                    درخواست شما با موفقیت ثبت شد
                </p>
                <p className={classes['desc']}>
                    طی ۲۴ تا ۴۸ ساعت آینده امکان معامله برای شما فراهم خواهد شد،
                </p>
                <p className={classes['desc']}>
                    فعالسازی حساب از طریق پیامک به شما اطلاع‌ داده می‌شود.
                </p>
            </div>
            <div onClick={(event) => event.stopPropagation()} className={classes['gridButton']}>
                <Button

                    className={classes['Button']}
                    onClick={() => handelClick()}
                >
                    ثبت درخواست متوفی
                </Button>
            </div>

        </ModalCustom>

    )
}


export default Contract;